import NextArrowImage from "../../assets/img/icons/user/nextArrow.png";
import React from "react";

export function SampleNextArrow(props) {
    const {className, style, onClick} = props;
    return (
        <div onClick={onClick}>
            <img src={NextArrowImage} alt="Next" className={`${className}`}
                 style={{...style, display: "block", width: "auto", height: "auto"}}/>
        </div>

    );
}